export default "__VITE_PUBLIC_ASSET__761b8165__"